import React from "react";

import usaLogoImage from "@/assets/images/holiday/truth-logo-usa.svg";
import { cn } from "@/utils/cn";
import { isJulyFourth } from "@/utils/dates";

import SiteLogo from "./site-logo";

type HomeLogoProps = React.ComponentProps<typeof SiteLogo>;

function shouldShowHolidayLogo(): boolean {
  if (
    new URLSearchParams(window.location.search).get("holiday-logo") === "1"
  ) {
    return true;
  }

  return isJulyFourth();
}

/** Home navigation logo; swaps to the USA variant on July 4th (local time). */
const HomeLogo: React.FC<HomeLogoProps> = ({ className, ...rest }) => {
  if (shouldShowHolidayLogo()) {
    return (
      <img
        className={cn("object-contain", className)}
        src={usaLogoImage}
        {...rest}
      />
    );
  }

  return <SiteLogo className={className} {...rest} />;
};

export default HomeLogo;
